<template>
  <div class="cookies" v-show="showCookiesBanner">
    <div class="container">

      <div class="title">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_826_546)">
            <path
                d="M60.6621 41.1895C60.7658 40.845 60.6933 40.4959 60.4531 40.1582C60.2051 39.8095 59.7943 39.5056 59.3223 39.335C56.2029 38.2074 55.415 35.1553 55.2461 32.2715C55.1959 31.4137 54.3742 30.6877 53.4111 30.7139C53.2943 30.717 53.1771 30.7188 53.0596 30.7188C45.6691 30.7187 39.7031 24.6137 39.7031 17.1133C39.7031 15.1804 39.9391 13.5807 40.5273 12.1475C41.1177 10.7091 42.0418 9.49058 43.3389 8.28809C43.3896 8.24101 43.4275 8.18879 43.4531 8.13672C43.5382 7.96326 43.516 7.67961 43.2871 7.41895C42.4529 6.46876 42.1191 5.40876 42.2227 4.10938C42.2886 3.28224 41.9303 2.64981 41.4043 2.46387C38.2642 1.35398 34.8922 0.750001 31.3799 0.750001C14.4773 0.750074 0.749999 14.7274 0.749999 32C0.749999 49.2727 14.4773 63.2499 31.3799 63.25C45.1525 63.25 56.8139 53.9725 60.6621 41.1895Z"
                fill="#F69C4A" stroke="#022E4E" stroke-width="1.5" stroke-linecap="round"/>
            <path
                d="M46.1912 19.6491C46.1912 17.4619 47.9651 15.6888 50.1532 15.6888C52.3414 15.6888 54.1152 17.4619 54.1152 19.6491C54.1152 21.8363 52.3414 23.6094 50.1532 23.6094C47.9651 23.6094 46.1912 21.8363 46.1912 19.6491Z"
                fill="#7C3715"/>
            <path
                d="M13.9102 23.7534C13.9102 22.3012 12.732 21.1235 11.2783 21.1235C9.82479 21.1237 8.64746 22.3013 8.64746 23.7534C8.64755 25.2055 9.82485 26.3831 11.2783 26.3833C12.7319 26.3833 13.9101 25.2056 13.9102 23.7534Z"
                stroke="#022E4E" stroke-width="1.5" stroke-linecap="round"/>
            <path
                d="M25.5295 8.34911C25.5295 5.8798 27.5322 3.87803 30.0025 3.87803C32.4729 3.87803 34.4756 5.8798 34.4756 8.34911C34.4756 10.8184 32.4729 12.8202 30.0025 12.8202C27.5322 12.8202 25.5295 10.8184 25.5295 8.34911Z"
                fill="#7C3715"/>
            <path
                d="M37.9891 46.3566C37.9891 44.1694 39.7629 42.3963 41.9511 42.3963C44.1392 42.3963 45.9131 44.1694 45.9131 46.3566C45.9131 48.5438 44.1392 50.3169 41.9511 50.3169C39.7629 50.3169 37.9891 48.5438 37.9891 46.3566Z"
                fill="#7C3715"/>
            <path
                d="M39.5801 31.9998C39.5801 30.5475 38.4019 29.3699 36.9482 29.3699C35.4947 29.37 34.3174 30.5476 34.3174 31.9998C34.3175 33.4518 35.4948 34.6295 36.9482 34.6296C38.4019 34.6296 39.58 33.4519 39.5801 31.9998Z"
                stroke="#022E4E" stroke-width="1.5" stroke-linecap="round"/>
            <path
                d="M23.1496 47.6217C25.4852 45.2871 25.3979 41.2903 22.7981 38.6916C20.1982 36.093 16.1996 36.0057 13.8641 38.3402C11.5287 40.6747 11.6159 44.6716 14.2156 47.2703C16.8154 49.8689 20.8141 49.956 23.1496 47.6217Z"
                stroke="#022E4E" stroke-width="1.5" stroke-linecap="round"/>
            <path
                d="M63.25 25.3735C63.2497 24.3296 62.4027 23.4829 61.3574 23.4829C60.3123 23.4831 59.4661 24.3297 59.4658 25.3735C59.4658 26.4176 60.3122 27.265 61.3574 27.2651C62.4028 27.2651 63.25 26.4177 63.25 25.3735Z"
                stroke="#022E4E" stroke-width="1.5" stroke-linecap="round"/>
            <path
                d="M19.0777 28.8575C19.0777 27.3989 20.2607 26.2164 21.72 26.2164C23.1793 26.2164 24.3623 27.3989 24.3623 28.8575C24.3623 30.3162 23.1793 31.4987 21.72 31.4987C20.2607 31.4987 19.0777 30.3162 19.0777 28.8575Z"
                fill="#7C3715"/>
            <path
                d="M56.8457 7.26831C56.8457 5.97431 55.7963 4.92481 54.501 4.92456C53.2055 4.92456 52.1553 5.97416 52.1553 7.26831C52.1553 8.56243 53.2055 9.61206 54.501 9.61206C55.7963 9.61181 56.8457 8.56227 56.8457 7.26831Z"
                stroke="#022E4E" stroke-width="1.5" stroke-linecap="round"/>
          </g>
          <defs>
            <clipPath id="clip0_826_546">
              <rect width="64" height="64" fill="white"
                    transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 64 64)"/>
            </clipPath>
          </defs>
        </svg>
        <p>Цей веб-сайт використовує файли cookie</p>
      </div>
      <p class="text">
        Щоб покращити ваш досвід перегляду, ми використовуємо файли cookie. Продовжуючи користуватися нашим сайтом, ви
        погоджуєтеся з нашою
        <a href="/pdf/privacy_policy.pdf" target="_blank">Політикою конфіденційності</a> та використанням файлів cookie.
      </p>

      <div class="btn-wrapper">
        <div @click="rejectAll" class="reject">
          Відхилити
        </div>
        <div @click="acceptAll" class="accept">
          прийняти
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showCookiesBanner: true,
      targetCookies: false,
      functionalCookies: false,
      operationalCookies: false,
    };
  },
  methods: {

    hideBanner() {
      this.showCookiesBanner = false;

      localStorage.setItem('cookies', this.showCookiesBanner);

    },
    // end banner nav
    setCookie(name, value, options = {}) {
      options = {
        path: "/",
        ...options,
      };

      if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
      }

      let updatedCookie =
          encodeURIComponent(name) + "=" + encodeURIComponent(value);

      for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
          updatedCookie += "=" + optionValue;
        }
      }

      document.cookie = updatedCookie;
    },
    getCookie(name) {
      let matches = document.cookie.match(
          new RegExp(
              "(?:^|; )" +
              name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
              "=([^;]*)"
          )
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    deleteCookie(name) {
      this.setCookie(name, "", {
        "max-age": -1,
      });
    },
    cookiesDelete() {
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;";
        document.cookie = name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      }
    },

    acceptAll() {

      this.targetCookies = true;
      this.functionalCookies = true;
      this.operationalCookies = true;

      this.hideBanner();
      this.acceptCookies();
      // setTimeout(() => {
      //   window.location.reload()
      // }, 1)

    },
    rejectAll() {

      this.targetCookies = false;
      this.functionalCookies = false;
      this.operationalCookies = false;

      this.hideBanner();
      this.acceptCookies();
      // setTimeout(() => {
      //   window.location.reload()
      // }, 1)


    },
    accept() {
      this.hideBanner();
      this.acceptCookies();

      // setTimeout(() => {
      //   window.location.reload()
      // }, 1)

    },

    acceptCookies() {
      this.cookiesDelete();


      let expires = new Date(new Date().valueOf() + 30000 * 60 * 60 * 24 * 15);
      document.cookie = "Bexsero-targetCookies=" + this.targetCookies + "; expires=" + expires;
      document.cookie = "Bexsero-functionalCookies=" + this.functionalCookies + "; expires=" + expires;
      document.cookie = "Bexsero-operationalCookies=" + this.operationalCookies + "; expires=" + expires;

      if (!this.showCookiesBanner) {
        let expires = new Date(new Date().valueOf() + 30000 * 60 * 60 * 24 * 15);
        document.cookie = "Bexsero-scb=false; expires=" + expires;
      }

      if (this.targetCookies) {

        console.log("targetCookies");
      } else {
        let fb = document.querySelector('meta[name="facebook-domain-verification"]');
        if (fb) {
          document.querySelector('meta[name="facebook-domain-verification"]').remove();
          console.log("fb removed");
        }

      }

      if (this.functionalCookies) {
        // -
        console.log("functionalCookies");
      }

      if (this.operationalCookies) {
        console.log("operationalCookies");

        (function () {
          window.dataLayer = window.dataLayer || [];

          function gtag() {
            dataLayer.push(arguments);
          }

          gtag('js', new Date());

          gtag('config', 'G-R5454X43XH');
        })();


      } else {
        // delete window.dataLayer;
        // window.gtag = function(){
        //   // stub function
        // }
        const cyrb53 = function (str, seed = 0) {
          let h1 = 0xdeadbeef ^ seed,
              h2 = 0x41c6ce57 ^ seed;
          for (let i = 0, ch; i < str.length; i++) {
            ch = str.charCodeAt(i);
            h1 = Math.imul(h1 ^ ch, 2654435761);
            h2 = Math.imul(h2 ^ ch, 1597334677);
          }
          h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
          h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
          return 4294967296 * (2097151 & h2) + (h1 >>> 0);
        };

        let clientIP = fetch('https://api.ipify.org?format=json')
            .then(x => x.json())
            .then(({ip}) => {
              return ip;
            });
        let validityInterval = Math.round(new Date() / 1000 / 3600 / 24 / 4);
        let clientIDSource = clientIP + ";" + window.location.host + ";" + navigator.userAgent + ";" + navigator.language + ";" + validityInterval;
        let clientIDHashed = cyrb53(clientIDSource).toString(16);

        window.dataLayer = window.dataLayer || [];

        gtag('js', new Date());
      }
    }

  },
  mounted() {
    if (this.showCookiesBanner) {
      this.showCookiesBanner = this.getCookie("Bexsero-scb") !== "false" ? true : false;

      this.targetCookies = this.getCookie('Bexsero-targetCookies') === "true" ? true : false;
      this.functionalCookies = this.getCookie('Bexsero-functionalCookies') === "true" ? true : false;
      this.operationalCookies = this.getCookie('Bexsero-operationalCookies') === "true" ? true : false;

      this.acceptCookies();

    }
  },
};
</script>

<style scoped lang="scss">

.title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  svg {
    width: 64px;
    min-width: 64px;
    height: auto;
    display: block;
    margin-right: 20px;
  }

  p {
    color: var(--black-text, #393939);

    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 124%;

    @media screen and (max-width: 375px) {
      font-size: 18px;
    }
  }
}

.text {
  color: #393939;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 132%;
  margin-bottom: 40px;

  a {
    text-decoration: underline;

    color: #393939;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;

    &:hover {
      text-decoration: none;
    }

  }
}

.cookies {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 15vh;
  right: 0;

  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.btn-wrapper {
  display: flex;
  align-items: center;
  gap: 20px;

  .accept {
    padding: 12px 22px;
    max-width: 202px;
    width: 100%;

    border-radius: 80px;
    background: #AA6DE3;

    color: #FFF;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 110%;
    letter-spacing: 1px;
    text-transform: uppercase;

    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
  }

  .reject {
    max-width: 202px;
    width: 100%;
    padding: 12px 22px;
    border-radius: 80px;
    border: 1px solid #AA6DE3;

    color: var(--violet, #AA6DE3);
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 110%;
    letter-spacing: 1px;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
  }
}

.container {
  padding: 40px;
  max-width: 590px;
  width: 100%;
  background-color: white;
  border-radius: 24px;

  @media screen and (max-width: 1024px) {

    max-width: 452px;
  }

  @media screen and (max-width: 600px) {
    padding: 20px;
  }
}
</style>